import { render } from "./tab-switch.vue?vue&type=template&id=44c44476&scoped=true"
import script from "./tab-switch.vue?vue&type=script&lang=ts"
export * from "./tab-switch.vue?vue&type=script&lang=ts"

import "./tab-switch.vue?vue&type=style&index=0&id=44c44476&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-44c44476"

export default script